<template>
    <gProductList
        v-if="productListInit"
        :list="list"
        :haveSort="false"
        :haveFunc="false"
        :havePageination="false"

        @sendEvent="receiveEvent"
    ></gProductList>
    <div
        v-else
        class="g mask-box-side"
    >
        <transition name="fade">
            <mdLoading></mdLoading>
        </transition>
    </div>
</template>

<script>
    import gProductList from '@/components/gProductList'
    import mdLoading from '@/components/mdLoading'
    
    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            gProductList,
            mdLoading,
        },
        computed: {
            ...mapState([
                'productList',
                'productListInit',
            ]),
            list: function(){
                let $data = this.productList || [],
                    $result = []

                $data.filter(item => item.is_favorite).forEach(item => {
                    
                    let $node = {
                            node: item,
                            class: item.class,
                            product_b: item.product_b,
                            product_m: item.product_m,
                            product_s: item.product_s,
                            alias: item.alias,
                            sn: item.product_sn,
                            label: item.label || '',
                            caption: item.product_s,
                            essay: item.product_b +'-'+ item.product_m,
                            image: item.imageurl,
                            favorite: item.is_favorite,
                            show: true,
                        }

                    $result.push($node);
                });

                return $result;
            },
        },
        methods: {
            ...mapMutations([
                'catchError',
                'changeProduct',
                'pushPopUp',
                'setFavorite',
            ]),
            favorite: function(opt){ //一定是 remove

                this.setFavorite({
                    sn: opt.sn,
                    favorite: false,
                });
            },
            contact: function(sn){
                this.$emit('sendEvent', 'contact', sn);
            },
        },
    }
</script>

<style scoped lang="scss">

    .g.mask-box-side {

        &::v-deep {

            .md.loading {
                height: calc(100vh - 160px);
            }
        }
    }
</style>
